<ui-dialog
    #activateWorkersCompensation
    [open]="isActivateWorkersCompensationModalOpen"
    (closing)="closeActivateWorkersCompensationModal()"
    header="payroll.settings.activateWorkersCompModal.header"
    primaryButtonLabel="payroll.settings.activateWorkersCompModal.primaryButton"
    (primaryButtonPressed)="onActivateWorkersCompensation()"
    secondaryButtonLabel="cancel"
    (secondaryButtonPressed)="closeActivateWorkersCompensationModal()"
>
    <p>{{ 'payroll.settings.activateWorkersCompModal.content' | translate }}</p>
</ui-dialog>

<ui-dialog
    formDialog
    [form]="roeContactSettiingForm"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    size="small"
    [open]="isRoeContactDialogOpen"
    [header]="(isEditRoeContactMode ? 'payroll.settings.editRoeContact' : 'payroll.settings.addRoeContact') | translate"
    (primaryButtonPressed)="onSave()"
    (secondaryButtonPressed)="closeRoeContactDialog()"
    (closing)="closeRoeContactDialog()"
>
    <form #roeContactSettiingForm="ngForm" autocomplete="off">
        <div *ngIf="settings" class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsFirstName' | translate }}</mat-label>
                <input
                    name="roeContactFirstName"
                    [(ngModel)]="settings.roeContactFirstName"
                    #roeContactFirstName="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="roeContactFirstName.invalid">{{ roeContactFirstName.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsLastName' | translate }}</mat-label>
                <input
                    name="roeContactLastName"
                    [(ngModel)]="settings.roeContactLastName"
                    #roeContactLastName="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="roeContactLastName.invalid">{{ roeContactLastName.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsAreaCode' | translate }}</mat-label>
                <input
                    name="roeContactAreaCode"
                    placeholder="647"
                    [(ngModel)]="settings.roeContactAreaCode"
                    #roeContactAreaCode="ngModel"
                    required
                    matInput
                    type="tel"
                    minlength="3"
                    maxlength="3"
                />
                <mat-error *ngIf="roeContactAreaCode.invalid">{{ roeContactAreaCode.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsPhoneNumber' | translate }}</mat-label>
                <input
                    name="roeContactPhoneNumber"
                    placeholder="1234567"
                    [(ngModel)]="settings.roeContactPhoneNumber"
                    #roeContactPhoneNumber="ngModel"
                    required
                    matInput
                    type="tel"
                    minlength="7"
                    maxlength="7"
                />
                <mat-error *ngIf="roeContactPhoneNumber.invalid">{{
                    roeContactPhoneNumber.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsExtensionNumber' | translate }}</mat-label>
                <input
                    name="roeContactPhoneExtensionNumber"
                    [(ngModel)]="settings.roeContactPhoneExtensionNumber"
                    #roeContactPhoneExtensionNumber="ngModel"
                    matInput
                    type="tel"
                    maxlength="8"
                />
                <mat-error *ngIf="roeContactPhoneExtensionNumber.invalid">{{
                    roeContactPhoneExtensionNumber.errors | formErrors
                }}</mat-error>
            </mat-form-field>
        </div>
    </form>
</ui-dialog>

<ui-dialog
    formDialog
    [form]="taxFormContactSettiingForm"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    size="small"
    [open]="isTaxFormContactDialogOpen"
    [header]="
        (isEditTaxFormContactMode ? 'payroll.settings.editTaxFormContact' : 'payroll.settings.addTaxFormContact')
            | translate
    "
    (primaryButtonPressed)="onSave()"
    (secondaryButtonPressed)="closeTaxFormContactDialog()"
    (closing)="closeTaxFormContactDialog()"
>
    <form #taxFormContactSettiingForm="ngForm" autocomplete="off">
        <div *ngIf="settings" class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsFirstName' | translate }}</mat-label>
                <input
                    name="taxFormContactFirstName"
                    [(ngModel)]="settings.taxFormContactFirstName"
                    #taxFormContactFirstName="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="taxFormContactFirstName.invalid">{{
                    taxFormContactFirstName.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsLastName' | translate }}</mat-label>
                <input
                    name="taxFormContactLastName"
                    [(ngModel)]="settings.taxFormContactLastName"
                    #taxFormContactLastName="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="taxFormContactLastName.invalid">{{
                    taxFormContactLastName.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsAreaCode' | translate }}</mat-label>
                <input
                    name="taxFormContactAreaCode"
                    placeholder="647"
                    [(ngModel)]="settings.taxFormContactAreaCode"
                    #taxFormContactAreaCode="ngModel"
                    required
                    matInput
                    type="tel"
                    minlength="3"
                    maxlength="3"
                />
                <mat-error *ngIf="taxFormContactAreaCode.invalid">{{
                    taxFormContactAreaCode.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsPhoneNumber' | translate }}</mat-label>
                <input
                    name="taxFormContactPhoneNumber"
                    placeholder="1234567"
                    [(ngModel)]="settings.taxFormContactPhoneNumber"
                    #taxFormContactPhoneNumber="ngModel"
                    required
                    matInput
                    type="tel"
                    minlength="7"
                    maxlength="7"
                />
                <mat-error *ngIf="taxFormContactPhoneNumber.invalid">{{
                    taxFormContactPhoneNumber.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsExtensionNumber' | translate }}</mat-label>
                <input
                    name="taxFormContactPhoneExtensionNumber"
                    [(ngModel)]="settings.taxFormContactPhoneExtensionNumber"
                    #taxFormContactPhoneExtensionNumber="ngModel"
                    matInput
                    type="tel"
                    maxlength="8"
                />
                <mat-error *ngIf="taxFormContactPhoneExtensionNumber.invalid">{{
                    taxFormContactPhoneExtensionNumber.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'payroll.settings.contactsEmail' | translate }}</mat-label>
                <input
                    name="taxFormContactEmail"
                    [(ngModel)]="settings.taxFormContactEmail"
                    #taxFormContactEmail="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="taxFormContactEmail.invalid">{{ taxFormContactEmail.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </form>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <ng-container *ngIf="settings">
        <app-header title="payroll.settings.title" [menuService]="payrollModuleMenuService"></app-header>

        <form class="ui form" #form="ngForm" autocomplete="off">
            <ui-card>
                <app-segment-header [title]="'payroll.settings.paystubs'"></app-segment-header>
                <div class="flex col">
                    <mat-label id="send_paystub_notification_emails_label">{{
                        'payroll.settings.notifyEmployeesWhenPaystubsAreReadyToBeViewedInHumi' | translate
                    }}</mat-label>
                    <mat-radio-group
                        name="send_paystub_notification_emails"
                        class="margin-top-1 margin-bottom-4"
                        [(ngModel)]="settings.sendPaystubNotificationEmails"
                        (ngModelChange)="onSave()"
                        aria-labelledby="send_paystub_notification_emails_label"
                    >
                        <mat-radio-button [value]="true" class="margin-bottom-2">{{
                            'yes' | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="false" class="margin-bottom-2">{{
                            'no' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>

                    <mat-label id="should_delay_paystub_to_cheque_date_label">{{
                        'payroll.settings.delayEmployeePaystubViewUntilTheChequeDate' | translate
                    }}</mat-label>
                    <mat-radio-group
                        name="should_delay_paystub_to_cheque_date"
                        class="margin-top-1 margin-bottom-4"
                        [(ngModel)]="settings.shouldDelayPaystubToChequeDate"
                        (ngModelChange)="onSave()"
                        aria-labelledby="should_delay_paystub_to_cheque_date_label"
                    >
                        <mat-radio-button [value]="true" class="margin-bottom-2">{{
                            'yes' | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="false" class="margin-bottom-2">{{
                            'no' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>

                    <mat-label id="show_vacation_pay_accruals_in_paystubs_label">{{
                        'payroll.settings.showVacationPayAccrualsInPaystubs' | translate
                    }}</mat-label>
                    <mat-radio-group
                        name="show_vacation_pay_accruals_in_paystubs"
                        class="margin-top-1"
                        [(ngModel)]="settings.displayTimeOffMoneyBalanceInPaystub"
                        (ngModelChange)="onSave()"
                        aria-labelledby="show_vacation_pay_accruals_in_paystubs_label"
                    >
                        <mat-radio-button [value]="true" class="margin-bottom-2">{{
                            'yes' | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="false" class="margin-bottom-2">{{
                            'no' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header
                    title="payroll.settings.workersCompensation"
                    [badgeOptions]="workersCompensationBadgeOptions"
                >
                </app-segment-header>
                <ng-container *ngIf="!canActivateWorkersCompensation">
                    <div [innerHTML]="'payroll.settings.workersCompActiveHelp' | translate"></div>
                </ng-container>
                <ng-container *ngIf="canActivateWorkersCompensation">
                    <div [innerHTML]="'payroll.settings.workersCompNotActiveHelp' | translate"></div>

                    <!-- This br is here to maintain the spacing between the last <p> in the translated text and the <ui-button> below -->
                    <br />

                    <ui-button type="primary" (click)="openActivateWorkersCompensationModal()"
                        >{{ 'payroll.settings.activateWorkersCompensation' | translate }}
                    </ui-button>
                </ng-container>
            </ui-card>

            <ui-card *ngIf="!this.hasPayrollContactFlag">
                <app-segment-header title="payroll.settings.companysRoeContact">
                    <div class="buttons" *ngIf="!companySettingsEditMode">
                        <ui-button type="link" (click)="toggleEditCompanySettingsInformation()">
                            {{ 'edit' | translate }}
                        </ui-button>
                    </div>
                    <div class="buttons" *ngIf="companySettingsEditMode">
                        <ui-button type="link" (click)="cancelCompanySettingsEdit()">{{
                            'cancel' | translate
                        }}</ui-button>
                        <ui-button type="primary" (click)="onSave()">{{
                            'payroll.settings.saveChanges' | translate
                        }}</ui-button>
                    </div>
                </app-segment-header>
                <ui-banner variant="info" class="padding-bottom-3">{{
                    'payroll.settings.roeInfo' | translate
                }}</ui-banner>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsFirstName' | translate }}</label>
                    <input
                        matInput
                        type="text"
                        name="roe_contact_first_name"
                        #ROEContactFirstName="ngModel"
                        required
                        [disabled]="!companySettingsEditMode"
                        [(ngModel)]="settings.roeContactFirstName"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsLastName' | translate }}</label>
                    <input
                        matInput
                        type="text"
                        name="roe_contact_last_name"
                        #ROEContactLastName="ngModel"
                        required
                        [disabled]="!companySettingsEditMode"
                        [(ngModel)]="settings.roeContactLastName"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsAreaCode' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="roe_contact_area_code"
                        #ROEContactAreaCode="ngModel"
                        required
                        minlength="3"
                        maxlength="3"
                        [disabled]="!companySettingsEditMode"
                        [(ngModel)]="settings.roeContactAreaCode"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsPhoneNumber' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="roe_contact_phone_number"
                        #ROEContactPhoneNumber="ngModel"
                        required
                        minlength="7"
                        maxlength="7"
                        [disabled]="!companySettingsEditMode"
                        [(ngModel)]="settings.roeContactPhoneNumber"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsExtensionNumber' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="roe_contact_phone_extension_number"
                        #ROEContactPhoneExtensionNumber="ngModel"
                        [disabled]="!companySettingsEditMode"
                        [(ngModel)]="settings.roeContactPhoneExtensionNumber"
                    />
                </div>
            </ui-card>

            <ui-card *ngIf="payrollEnabled && !this.hasPayrollContactFlag">
                <app-segment-header title="payroll.settings.companysTaxFormContact">
                    <div class="buttons" *ngIf="!companyTaxFormEditMode">
                        <ui-button type="link" (click)="toggleEditTaxFormContactInformation()">
                            {{ 'edit' | translate }}
                        </ui-button>
                    </div>
                    <div class="buttons" *ngIf="companyTaxFormEditMode">
                        <ui-button type="link" (click)="cancelTaxFormSettingsEdit()">{{
                            'cancel' | translate
                        }}</ui-button>
                        <ui-button type="primary" (click)="onSave()">{{
                            'payroll.settings.saveChanges' | translate
                        }}</ui-button>
                    </div>
                </app-segment-header>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsFirstName' | translate }}</label>
                    <input
                        matInput
                        type="text"
                        name="tax_form_contact_first_name"
                        #TaxFormContactFirstName="ngModel"
                        required
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactFirstName"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsLastName' | translate }}</label>
                    <input
                        matInput
                        type="text"
                        name="tax_form_contact_last_name"
                        #TaxFormContactLastName="ngModel"
                        required
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactLastName"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsAreaCode' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="tax_form_contact_area_code"
                        #TaxFormContactAreaCode="ngModel"
                        required
                        minlength="3"
                        maxlength="3"
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactAreaCode"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsPhoneNumber' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="tax_form_contact_phone_number"
                        #TaxFormContactPhoneNumber="ngModel"
                        required
                        minlength="7"
                        maxlength="7"
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactPhoneNumber"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsExtensionNumber' | translate }}</label>
                    <input
                        matInput
                        type="tel"
                        name="tax_form_contact_phone_extension_number"
                        #TaxFormContactPhoneExtensionNumber="ngModel"
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactPhoneExtensionNumber"
                    />
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.contactsEmail' | translate }}</label>
                    <input
                        matInput
                        type="email"
                        name="tax_form_contact_email"
                        #TaxFormContactEmail="ngModel"
                        [disabled]="!companyTaxFormEditMode"
                        [(ngModel)]="settings.taxFormContactEmail"
                    />
                </div>
            </ui-card>

            <ui-card *ngIf="this.hasPayrollContactFlag">
                <h2>{{ 'payroll.settings.payrollContacts' | translate }}</h2>
                <h3>{{ 'payroll.settings.payrollAdminContacts' | translate }}</h3>
                <div class="margin-bottom-3">{{ 'payroll.settings.payrollContactsDescription' | translate }}</div>

                <hr class="lighter margin-top-2" />

                <div>
                    <h3>{{ 'payroll.settings.roeContact' | translate }}</h3>
                    <div class="margin-bottom-3">{{ 'payroll.settings.roeContactDescription' | translate }}</div>

                    <app-simple-table
                        [showMeatballs]="true"
                        [showDeleteItem]="false"
                        [attr.data-cy]="'payrollRoeContactSimpleTable'"
                        (editClicked)="onRoeContactEdit(true)"
                        *ngIf="roeContactRows?.length > 0"
                        [columns]="roeContactColumns"
                        [rows]="roeContactRows"
                    ></app-simple-table>

                    <ui-button
                        *ngIf="!roeContactRows?.length"
                        (click)="onRoeContactEdit(false)"
                        class="margin-bottom-2"
                        type="link"
                    >
                        <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                        <span>{{ 'payroll.settings.addContact' | translate }}</span></ui-button
                    >
                </div>

                <hr class="lighter margin-top-2" />

                <div>
                    <h3>{{ 'payroll.settings.taxFormContact' | translate }}</h3>

                    <div class="margin-bottom-3">{{ 'payroll.settings.taxFormContactDescription' | translate }}</div>

                    <app-simple-table
                        [showMeatballs]="true"
                        [showDeleteItem]="false"
                        [attr.data-cy]="'payrollTaxFormContactSimpleTable'"
                        (editClicked)="onTaxFormContactEdit(true)"
                        *ngIf="taxFormContactRows?.length > 0"
                        [columns]="taxFormContactColumns"
                        [rows]="taxFormContactRows"
                    ></app-simple-table>

                    <ui-button
                        *ngIf="!taxFormContactRows?.length"
                        (click)="onTaxFormContactEdit(false)"
                        class="margin-bottom-2"
                        type="link"
                    >
                        <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                        <span>{{ 'payroll.settings.addContact' | translate }}</span></ui-button
                    >
                </div>
            </ui-card>

            <ui-card *ngIf="settings?.schedule">
                <app-segment-header title="payroll.settings.schedule"></app-segment-header>
                <div class="inline field">
                    <label>{{ 'payroll.settings.payrollStartDate' | translate }}</label>
                    <p>{{ settings?.schedule?.startDate }}</p>
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.frequency' | translate }}</label>
                    <p>{{ scheduleFrequency | translate }}</p>
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.dayOfTheWeek' | translate }}</label>
                    <p>{{ scheduleDayOfTheWeek | translate }}</p>
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.daysOfTheMonth' | translate }}</label>
                    <p>
                        {{
                            scheduleDaysOfTheMonth
                                | translate
                                    : { first: days && days[0], last: days && days[1] < 0 ? 'last' : days && days[1] }
                        }}
                    </p>
                </div>
                <div class="inline field">
                    <label>{{ 'payroll.settings.daysInArrears' | translate }}</label>
                    <p>{{ settings?.schedule?.daysInArrears }}</p>
                </div>
            </ui-card>

            <ui-card *ngIf="hasQcPayrollFeature" class="qhsf-card">
                <app-segment-header title="payroll.settings.qhsf.title"></app-segment-header>
                <div [innerHTML]="'payroll.settings.qhsf.description' | translate"></div>
                <ui-banner variant="info" class="qhsf-banner">{{ 'payroll.settings.qhsf.info' | translate }}</ui-banner>
                <div class="flex align-items-center">
                    <mat-form-field class="flex">
                        <mat-label>{{ 'payroll.settings.qhsf.label' | translate }}</mat-label>
                        <input
                            class="no-arrow-buttons"
                            matInput
                            type="number"
                            name="qhsfRate"
                            placeholder="0.00"
                            [min]="0"
                            [max]="5"
                            step="0.01"
                            qhsfRateValidator
                            #qhsfRate="ngModel"
                            [(ngModel)]="settings.qhsfRate"
                        />
                        <mat-icon matSuffix svgIcon="percent"></mat-icon>
                        <mat-hint>{{ 'payroll.settings.qhsf.hint' | translate }}</mat-hint>
                        <mat-error *ngIf="qhsfRate.invalid">
                            {{ qhsfRate.errors | formErrors }}
                        </mat-error> </mat-form-field
                    ><ui-button class="flex" type="primary" (click)="onSave()">{{
                        'payroll.settings.qhsf.save' | translate
                    }}</ui-button>
                </div>

                <div [innerHTML]="'payroll.settings.qhsf.note' | translate"></div>
            </ui-card>
        </form>
    </ng-container>
</div>
